<template>
  <div class="order-goods-cont">
    <div class="order-goods-cont_title">
      <p v-if="orderItem.isPolitCity">
        <i class="business-ico"></i>
        <em>{{ orderItem.transName2 }}</em>
        <!-- <i class="icon-second"></i> -->
        <!-- <van-icon name="arrow" /> -->
      </p>
      <p
        v-else-if="orderItem.orderTag.includes('100008')"
      >
        <i class="business-ico"></i>
        <em>{{ orderItem.transName2 }}</em>
      </p>
      <p
        v-else
        @click.stop="toNext(`/shop/store/${orderItem.partnerShippingNote}`)"
      >
        <i class="business-ico"></i>
        <em>{{ orderItem.partnerPurchaseNote }}</em>
        <van-icon name="arrow" />
      </p>
      <span>{{ getStatusName(orderItem.orderStatus) }}</span>
    </div>
    <div
      v-for="(item, index) in orderItem.delevery[0].prd"
      :key="index"
      class="order_con"
    >
      <div
        class="order-package van-hairline--bottom"
        v-if="(orderItem.orderStatus === '5' || orderItem.orderStatus === '7')&& orderItem.orderTag.indexOf('B77')==-1"
      >
        <span>包裹号：({{ orderItem.delevery[0].packageId }})</span>
      </div>
      <div class="order-googds van-hairline--bottom">
        <div class="imgCon">
          <span class="ysIcon" v-if="orderItem.orderTag && (orderItem.orderTag.indexOf('B36')>=0)">预售</span>
          <img
            class="order-googds-img"
            :src="
              (item.productPic || '')
                .split('|*|')
                .shift()
                .replace('ule.com', 'ulecdn.com')
                .replace('.jpg', '_l.jpg')
                .replace('.png', '_l.png')
                .replace(/http:/, '')
            "
            alt=""
          />
        </div>
        <div class="order-googds-text">
          <p class="van-ellipsis">{{ item.productName }}</p>
          <!-- <p>包邮</p> -->
          <p class="order-googds-sku" v-html="item.attributes"></p>
          <p class="order-googds-num-con">
            <span class="total">数量:{{ item.productNum }}</span>
            <span
              class="return"
              v-if="
                item.outOffStockProductNum && item.outOffStockProductNum > 0
              "
              >退货/缺货:<i>{{ item.outOffStockProductNum }}</i></span
            >
          </p>
          <p class="order-googds-price">
            <span><i>单价:¥</i>{{ item.salPrice }}</span>
            <!-- <span class="order-googds-num">x {{ item.productNum }}</span> -->
          </p>
        </div>
      </div>
      <div
        class="return_tips"
        v-if="item.outOffStockProductNum && item.outOffStockProductNum > 0"
      >
        <van-icon class="icon" name="volume-o" />
        <p class="text">该商品存在缺货，请确认用户提货数量化</p>
      </div>
    </div>
    <div class="order-total">
      <p v-if="orderItem.orderStatus == 3">
        合计：¥
        <span>{{
          (
            Number(orderItem.order_amount) - Number(orderItem.pay_amount)
          ).toFixed(2)
        }}</span>
        (含运费¥{{ orderItem.transAmount }})
      </p>
      <p v-else>
        合计：¥ <span>{{ orderItem.order_amount }}</span> (含运费¥{{
          orderItem.transAmount
        }})
      </p>
    </div>
    <!-- 已取消 -->
    <div class="order-bottom van-hairline--top">
      <template v-if="orderItem.isAbleDelay != 1 || btnLength < 3">
        <div
          v-if="orderItem.isPolitCity"
          @click.stop="toPhone(orderItem.sitePhone)"
          style="padding-top:5px"
        >
          <a class="online" :href="`tel:${orderItem.sitePhone}`"
            ><span>联系团长</span><van-icon name="chat-o" size="15"
          /></a>
        </div>
        <div
          v-else-if="orderItem.orderTag.includes('100008')"
          @click.stop="toPhone(orderItem.sitePhone)"
          style="padding-top:5px"
        >
          <a style="color:#333;" :href="`tel:${orderItem.sitePhone}`"
            ><span>联系自提点</span><van-icon name="chat-o" size="15"
          /></a>
        </div>
        <div
          class="left-kefu"
          v-else-if="orderItem.kefuStatus"
          @click.stop="toKefu"
          style="padding-top:5px"
        >
          <span :class="{ actve: orderItem.kefuStatus }">联系商家</span>
          <van-icon name="chat-o" color="#ef3b39" size="15" />
        </div>
        <div class="left-kefu" v-else @click.stop="toKefu">
          <span>联系商家</span>
          <van-icon name="chat-o" size="15" />
        </div>
        
      </template>
      <template v-else>
        <div class="more-btn">
          <div @click.stop="showMoreBtn = !showMoreBtn">更多</div>
          <div class="more-popup" v-if="showMoreBtn">
            <div class="popup-item" v-if="orderItem.isPolitCity" @click.stop="toPhone(orderItem.sitePhone)">
              <div class="online" :href="`tel:${orderItem.sitePhone}`">
                <div class="span">联系团长</div>
              </div>
            </div>
            <div class="popup-item" v-else-if="orderItem.orderTag.includes('100008')" @click.stop="toPhone(orderItem.sitePhone)">
              <div style="color:#333;" :href="`tel:${orderItem.sitePhone}`">
                <div class="span">联系自提点</div>
              </div>
            </div>
            <div class="popup-item" v-else-if="orderItem.kefuStatus" @click.stop="toKefu">
              <div :class="{ actve: orderItem.kefuStatus }">联系商家</div>
            </div>
            <div class="popup-item" v-else @click.stop="toKefu">
              <div class="span">联系商家</div>
            </div>
            
            <div class="popup-item" v-if="showDelayBtn" @click.stop="onDelayOrder(orderItem.escOrderId)">延迟收货</div>
          </div>
        </div>
      </template>
      <div style="flex:1;display: flex;justify-content: flex-end;flex-flow: wrap;">
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="handleToInvoice(orderItem.escOrderId,0)"
          v-if="(orderItem.invoiceIssueStatus == '0' || orderItem.invoiceIssueStatus == '') && orderItem.orderStatus == '7'"
          >申请开票</van-button
        >
         <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="handleToInvoice(orderItem.escOrderId,1)"
          v-if="orderItem.invoiceIssueStatus != '0' && orderItem.invoiceIssueStatus != '' && (orderItem.orderStatus == '4' || orderItem.orderStatus == '5' || orderItem.orderStatus == '7')"
          >查看发票</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          v-if="orderItem.orderStatus === '4'"
          @click.stop="onDeliverReminder(orderItem.escOrderId)"
          >提醒发货</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="
            onCancelOrder(
              orderItem.escOrderId,
              orderItem.orderTag,
              orderItem.businessType
            )
          "
          v-if="orderItem.orderStatus === '3' || orderItem.orderStatus === '4'"
          >取消订单</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#EF3B39"
          v-if="orderItem.orderStatus === '5'"
          @click.stop="onUserSignOrder(orderItem.escOrderId)"
          >确认收货</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#EF3B39"
          v-if="orderItem.orderStatus === '3'"
          @click.stop="onOrderPay(orderItem.escOrderId)"
          >立即付款</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          v-if="(orderItem.orderStatus === '5' || orderItem.orderStatus === '7')&& orderItem.orderTag.indexOf('B77')==-1"
          @click.stop="
            toNextPage(orderItem)
          "
          >查看物流</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="handleWriteOff(orderItem.qrUrl)"
          v-if="orderItem.orderStatus != '1' && orderItem.orderStatus != '3' && orderItem.orderTag.indexOf('100019') > -1 && orderItem.qrUrl"
          >查看核销码</van-button
        >
        <!-- <van-button plain hairline round color="#EF3B39" v-if="orderItem.orderStatus === '7' && orderItem.feedback === '2'" @click.stop="onCommit(orderItem.escOrderId, orderItem)"
					>评价有礼 </van-button
				> -->
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="onDeleteOrder(orderItem.escOrderId)"
          v-if="orderItem.orderStatus === '1' || orderItem.orderStatus === '5'"
          >删除订单</van-button
        >
        <van-button
          plain
          hairline
          round
          color="#cccccc"
          class="order-bottom_cannel"
          @click.stop="onDelayOrder(orderItem.escOrderId)"
          v-if="orderItem.isAbleDelay == '1' && btnLength < 3 && showDelayBtn"
          >延迟发货</van-button
        >
      </div>
    </div>
		<van-popup v-model="isShowLogistic" round position="bottom" @click.stop="" closeable @closed="closeLogisticPop" @click-overlay.stop="closeLogisticPop">
			<logistic :order="orderItem"></logistic>
		</van-popup>	    
  </div>
</template>

<script>
import {
  deleteOrder,
  waitSignOrder,
  deliverReminder,
  orderPay,
  indexFeaturedGet,
  delayOrderApi
} from "@/libs/api";
import logistic from "@/components/logistic.vue";
export default {
  name: "orderItem",
  props: ["orderItem", "index"],
  components: { logistic },  
  data() {
    return {
      isShowCanncel: true,
      isShowLogistic: false,
      btnLength: 0,
      showDelayBtn: true,
      showMoreBtn: false
    };
  },
  mounted () {
    let count = 0
    if ((this.orderItem.invoiceIssueStatus == '0' || this.orderItem.invoiceIssueStatus == '') && this.orderItem.orderStatus == '7') {
      count++
    }
    if (this.orderItem.invoiceIssueStatus != '0' && this.orderItem.invoiceIssueStatus != '' && (this.orderItem.orderStatus == '4' || this.orderItem.orderStatus == '5' || this.orderItem.orderStatus == '7')) {
      count++
    }
    if (this.orderItem.orderStatus === '4') {
      count++
    }
    if (this.orderItem.orderStatus === '3' || this.orderItem.orderStatus === '4') {
      count++
    }
    if (this.orderItem.orderStatus === '5') {
      count++
    }
    if (this.orderItem.orderStatus === '3') {
      count++
    }
    if ((this.orderItem.orderStatus === '5' || this.orderItem.orderStatus === '7') && this.orderItem.orderTag.indexOf('B77')==-1) {
      count++
    }
    if (this.orderItem.orderStatus != '1' && this.orderItem.orderStatus != '3' && this.orderItem.orderTag.indexOf('100019') > -1) {
      count++
    }
    if (this.orderItem.orderStatus === '1' || this.orderItem.orderStatus === '5') {
      count++
    }
    this.btnLength = count
  },
  computed: {
    getStatusName() {
      return function(status) {
        if (status === "1") {
          return "已取消";
        } else if (status === "3") {
          return "待付款";
        } else if (status === "4") {
          return "待发货";
        } else if (status === "5") {
          return "待收货";
        } else if (status === "7") {
          return "已签收";
        } else if (status === "72") {
          return "待评价";
        }
      };
    },
    getTotal() {
      return function(item) {
        if (item.delevery.length > 0) {
          let total = 0;
          item.delevery[0].prd.forEach((ele) => {
            total += Number(ele.salPrice) * Number(ele.productNum);
          });
          // 如果有运费
          if (item.transAmount > 0) {
            total += Number(item.transAmount);
          }
          return total.toFixed(2);
        }
      };
    },
  },
  methods: {
    toNextPage(orderItem){
      if (/100008/.test(orderItem.orderTag) && /1016039299/.test(orderItem.unionId)) {
        	this.isShowLogistic = true;
      } else {
        let isPolitCity=orderItem.isPolitCity ? 1: 0;
        this.toNext(`/order/logistics/${orderItem.delevery[0].packageId}?isPolitCity=${isPolitCity}&orderTag=${orderItem.orderTag}`)
      }
    },
		// 关闭物流弹层
		closeLogisticPop() {
			this.isShowLogistic = false;
		},
    // 删除订单
    onDeleteOrder(escOrderId) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认是否要删除该订单?",
        })
        .then(() => {
          deleteOrder(
            { escOrderId, clientCallType: "H5" },
            "jsonCallback"
          ).then((res) => {
            if (res.code === "0000") {
              setTimeout(() => {
                this.$toast("删除成功");
                this.$emit("deleteIndex", this.index);
              }, 500);
            } else {
              this.$toast(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 取消订单
    onCancelOrder(escOrderId, orderTag, businessType) {
      this.showCanncelPop(escOrderId, orderTag, businessType);
    },
    // 确认收货
    onUserSignOrder(escOrderId) {
      let data = {
        escOrderId,
        clientCallType: "H5",
      };
      waitSignOrder(data, "jsonCallback")
        .then((res) => {
          if (res.code == "0000") {
            this.$toast("操作成功");
            setTimeout(() => {
              this.$emit("cancel");
            }, 2000);
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((error) => {
          this.$toast("查询失败！");
        });
    },
    // 提醒发货
    onDeliverReminder(escOrderId) {
      deliverReminder(
        { escOrderId, clientCallType: "H5" },
        "jsonCallback"
      ).then((res) => {
        this.$toast(res.msg);
      });
    },
    // 跳转客服
    toKefu() {
      let that = this;
      this.showMoreBtn = false
      let serviceUrl = `https://livechat.${this.$uleUrl()}/imweb/visitorBusinessMobile?channel=yxdsq&source=order&merchantId=${
        this.orderItem.sellerOnlyid
      }&storeId=${this.orderItem.storeId}&orderId=${this.orderItem.escOrderId}`;
      window.location.href = serviceUrl;
    },
    toPhone(phone) {
      console.log(phone);
      this.showMoreBtn = false
      // window.location.href = 'tel://' + phone;
    },
    handleToInvoice(escOrderId,type){
      // 开票
      if(type == 0){
        window.location.href = `https://h5.${this.$uleUrl()}/yxd/mall/order/invoice?escOrderId=${escOrderId}`
      }
      // 查看发票
      else{
        window.location.href = `https://h5.${this.$uleUrl()}/yxd/mall/order/invoiceView?escOrderId=${escOrderId}`
      }
    },
    // 确认支付
    onOrderPay(escOrderId) {
      orderPay({ escOrderIds: escOrderId, clientCallType: "H5" })
        .then((res) => {
          if (res.returnCode === "0000") {
            location.href = res.data.payUrl;
          } else {
            this.$toast(res.returnMessage);
          }
        })
        .catch((error) => {
          this.$toast("支付失败！");
        });
    },
    // 评价有礼
    onCommit(escOrderId, orderItem) {
      sessionStorage.setItem("messi0", JSON.stringify(orderItem));
      window.location.href = `https://m.${this.$uleUrl()}/maftersale/order/commentOrderPage?orderid=${escOrderId}&i=0&index=1`;
    },
    // 点击显示取消订单弹层
    showCanncelPop(escOrderId, orderTag, businessType) {
      this.$emit("canncelPop", true);
      this.$emit("orderId", escOrderId);
      this.$emit("orderIndex", this.index);
      this.$emit("orderTag", orderTag);
      this.$emit("businessType", businessType);
    },
    // 查看核销码
    handleWriteOff(url) {
      console.log("核销");
      window.location.href = url
    },
    // 延迟发货
    onDelayOrder (orderId) {
      this.showMoreBtn = false
      delayOrderApi({
        orderId,
        clientCallType: 'H5'
      })
        .then(res => {
          if (res.returnCode == '0000') {
            this.showDelayBtn = false
            this.$toast('延迟成功')
          } else {
            this.$toast(res.returnMessage)
          }
        })
    }
  },
};
</script>

<style scoped lang="scss">
.order-goods-cont {
  color: #333;
  &_title {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 10px;
    p {
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      .business-ico {
        width: 26px;
        height: 26px;
        background: url(../assets/img/p_business_icon.png);
        background-size: 100% 100%;
      }
      em {
        font-style: normal;
        margin: 0 0 0 10px;
      }
    }
    span {
      color: #ef3b39;
      &.nomal {
        color: #999999;
      }
    }
  }
  .icon-second {
    background: url(../assets/img/icon_second.png) no-repeat center center;
    // width:50px;
    background-size: 43px;
    padding: 20px 30px;
  }
  .order-package {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding: 0 10px 10px 10px;
  }
  .order-googds {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px 15px;
    // margin-bottom: 10px;
    .imgCon{
      position: relative;
      .ysIcon{
        position: absolute;
        left: 0;
        top: 0;
        color: #fff;
        background: #ef3b39;
        border-radius: 15px;
        padding: 2px 7px;
        font-size: 12px;
      }
    }    
    img {
      width: 90px;
      height: 90px;
      margin-right: 15px;
      border-radius: 6px;
    }
    .order-googds-text {
      width: 65%;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: stretch;
      align-content: stretch;
      .order-googds-sku {
        color: #999;
      }
      .order-googds-num-con {
        font-size: 12px;
        .total {
          color: #2c3e50;
          font-weight: bold;
        }
        .return {
          margin-left: 10px;
          font-weight: bold;
          i {
            color: #ef3b39;
          }
        }
      }
      .order-googds-price {
        display: flex;
        justify-content: space-between;
        // margin-top: 5px;
        font-size: 16px;
        align-items: flex-end;
        i {
          margin-right: 5px;
          font-size: 10px;
        }
        .order-googds-num {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
  .return_tips {
    display: flex;
    // justify-content: center;
    align-items: center;
    background: #fcf3f0;
    padding: 0 10px;
    height: 24px;
    .icon {
      font-size: 12px;
      color: #cb8768;
      font-weight: bold;
    }
    .text {
      font-size: 12px;
      color: #cb8768;
      font-weight: bold;
      margin-left: 5px;
    }
  }
  .order-total {
    color: #333;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    padding: 10px 10px;
    p {
      font-size: 12px;
      span {
        font-size: 16px;
      }
    }
  }
  .order-bottom {
    // margin-top: 10px;
    padding: 10px 10px 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: center;
    .left-kefu {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      span {
        margin-right: 5px;
        &.actve {
          color: #ef3b39;
        }
      }
    }
    button {
      margin-left: 5px;
      margin-bottom:8px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
    }
    &_cannel {
      .van-button__text {
        color: #666;
      }
    }
    .online {
      color: #ef3b39;
      .van-icon-chat-o {
        color: #ef3b39;
      }
    }
    .more-btn {
      position: relative;
      padding-top: 4px;
      .more-popup {
        position: absolute;
        top: 100%;
        left: 0;
        border: 1px solid #e4e4e4;
        border-radius: 6px;
        background-color: #fff;
        text-align: center;
        width: 80px;
        line-height: 32px;
        z-index: 10;
      }
    }
  }
  .active {
    color: #ef3b39;
  }
}
</style>
